import React, { useRef, useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'animate.css';
import Tooltip from '../UI/Tooltip';
import SharedModal from '../Modal/SharedModal';

export default function SentenceHtmlModal({ content, children, allowCopy }) {
  const toCopy = useRef(null);
  const modalContent = content ? content : children;
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopyClick = async () => {
    if (toCopy.current) {
      try {
        await navigator.clipboard.writeText(toCopy.current.textContent);
        setCopied(true);

        // Animación
        const copyButton = document.querySelector('.bi-copy');
        if (copyButton) {
          copyButton.classList.add('animate__flipInX');
          setTimeout(() => copyButton.classList.remove('animate__flipInX'), 1000);
        }

        setTimeout(() => setCopied(false), 3000);
      } catch (err) {
        console.error('Error copying text: ', err);
      }
    }
  };

  return (
    <>
      <div 
      className="space-x-2">
        <Tooltip placement="left" content="Click to see full sentence" allowCopy={true}>
          <button type="button" onClick={() => setOpen(true)}>
            <i className="bi bi-plus-circle-fill"></i>
          </button>
          {' '}
          <span 
            onClick={() => setOpen(true)}
            className="cursor-pointer"
            dangerouslySetInnerHTML={{ __html: children }}/>
        </Tooltip>
      </div>
      <SharedModal
        open={open}
        setOpen={setOpen}
        content={
          <div>
            <div
              ref={toCopy}
              dangerouslySetInnerHTML={{ __html: modalContent }}
              className="text-secondary font-weight-bold"
            />
            {allowCopy && (
              <div className="flex justify-end mt-2 mr-2">
                <button className="bi-copy animate__animated" onClick={handleCopyClick}>
                  {copied ? ' Copied!' : ' Copy'}
                </button>
              </div>
            )}
          </div>
        }
        allowCopy={allowCopy}
      />
    </>
  );
}
